var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinancierDesktopLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17188 6.44043L11.0019 11.5504L19.7719 6.4704",
    stroke: "#949699",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.61V11.54",
    stroke: "#949699",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9306 1.48L3.59061 4.45003C2.38061 5.12003 1.39062 6.80001 1.39062 8.18001V13.83C1.39062 15.21 2.38061 16.89 3.59061 17.56L8.9306 20.53C10.0706 21.16 11.9406 21.16 13.0806 20.53L18.4206 17.56C19.6306 16.89 20.6206 15.21 20.6206 13.83V8.18001C20.6206 6.80001 19.6306 5.12003 18.4206 4.45003L13.0806 1.48C11.9306 0.84 10.0706 0.84 8.9306 1.48Z",
    stroke: "#949699",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0017 12.2396V8.57965L6.51172 3.09961",
    stroke: "#949699",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancierDesktopLogo);
export default __webpack_public_path__ + "static/media/financierDesktopLogo.2ce846445a8f7a61022cdc4433c76432.svg";
export { ForwardRef as ReactComponent };